import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-bad-request',
    templateUrl: './bad-request.component.html',
    styleUrls: ['./bad-request.component.scss']
})
export class BadRequestComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
